import type { Path } from 'react-router';
import {
  // This is the only place where we should be using matchPath
  // oxlint-disable-next-line no-restricted-imports
  matchPath,
  resolvePath,
} from 'react-router';
import type { UnauthenticatedRoute } from '@gonfalon/router/generated/routeInfo';

export function matchUnauthenticatedRoute(pattern: UnauthenticatedRoute, path: Path) {
  return matchPath(pattern, resolvePath(path).pathname) !== null;
}
